<template>
  <ErrorBoundary module-name="SingleArticle">
    <component :is="template" />
  </ErrorBoundary>
</template>

<script lang="ts">
  import PromoTemplate from '~/containers/ArticleTemplates/Promo.vue';
  import OneColumn from '@/containers/ArticleTemplates/OneColumn.vue';
  import TwoColumn from '@/containers/ArticleTemplates/TwoColumn.vue';
  import BroadSide from '@/containers/ArticleTemplates/BroadSide.vue';
  import TableOfContents from '@/containers/ArticleTemplates/TableOfContents.vue';
  import ErrorBoundary from '@devhacker/shared/components/ErrorBoundary.vue';
  import { usePageStore } from '~/store/pagesData';

  export default defineNuxtComponent({
    name: 'SingleArticle',

    components: {
      PromoTemplate,
      OneColumn,
      TwoColumn,
      BroadSide,
      TableOfContents,
      ErrorBoundary,
    },

    setup() {
      return {
        nuxtApp: useNuxtApp(),
        pageStore: usePageStore(),
      };
    },

    computed: {
      template() {
        const templateMap = {
          promo: 'PromoTemplate',
          'one-column': 'OneColumn',
          'two-column': 'TwoColumn',
          broadside: 'BroadSide',
          toc: 'TableOfContents',
        };
        const templateName = this.pageStore.currentArticle?.template as keyof typeof templateMap;
        return templateMap[templateName];
      },
    },

    mounted() {
      document.addEventListener('click', this.handleArticleClick);
    },

    unmounted() {
      document.removeEventListener('click', this.handleArticleClick);
    },

    methods: {
      handleArticleClick(e: MouseEvent): void {
        // Рекламный блок яндекса приходит в двух обертках, убеждаемся что верхняя с id adfox
        const targetGrandParent = (e.target as HTMLElement | null)?.parentElement?.parentElement;

        if (targetGrandParent && targetGrandParent.id.includes('adfox')) {
          this.nuxtApp.$sendYandexMetrika({
            level1: 'Клик_РСЯ',
          });
        }
      },
    },
  });
</script>
